// Auto-join: when a signed-in user views someone else's album, record it so
// the album shows up on their dashboard under "Events you've joined".
import { useEffect } from "react";
import { useAuth } from "../lib/AuthContext";
import { Joined } from "../lib/api";

export default function useAutoJoin(album) {
  const { user } = useAuth();
  const slug = album?.slug;
  const ownerId = album?.owner_id;
  const userId = user?.user_id;

  useEffect(() => {
    if (!slug || !ownerId || !userId) return; // locked/unloaded albums have no owner_id
    if (ownerId === userId) return; // own album
    Joined.join(slug).catch(() => {});
  }, [slug, ownerId, userId]);
}
